var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgServiceCenterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    stroke: "white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.25C17.3848 22.25 21.75 17.8848 21.75 12.5C21.75 7.11522 17.3848 2.75 12 2.75C6.61522 2.75 2.25 7.11522 2.25 12.5C2.25 17.8848 6.61522 22.25 12 22.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.25C14.0711 16.25 15.75 14.5711 15.75 12.5C15.75 10.4289 14.0711 8.75 12 8.75C9.92893 8.75 8.25 10.4289 8.25 12.5C8.25 14.5711 9.92893 16.25 12 16.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3.03125L10.125 9.21875"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 9.21875L14.25 3.03125"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 21.9688L10.125 15.7812"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 15.7812L14.25 21.9688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4688 10.25L15.2812 10.625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2812 14.375L21.4688 14.75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53125 10.25L8.71875 10.625"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 14.375L2.53125 14.75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCenterIcon);
export default __webpack_public_path__ + "static/media/service-center-icon.1a86a53d.svg";
export { ForwardRef as ReactComponent };